import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

import { AddCardComponent } from '@teem/billing-module/modals/add-card/add-card.component';
import { BillingService } from '@teem/services/billing.service';
import { LoaderService } from '@teem/services/loader.service';
import { messages as i18n } from '@teem/constants/messages';



@Component({
  selector: 'subscription-history',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent implements OnInit {
  loadingSubscription: boolean = false;
  subscriptionList: any = [];

  constructor(
    private billingService: BillingService,
    private loaderService: LoaderService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.getMySubscription();
  }

  getMySubscription() {
    this.loadingSubscription = true;

    this.billingService.subscriptionList().subscribe((data: any) => {
      this.subscriptionList = data;
      this.loadingSubscription = false;
    }, err => {
      this.loadingSubscription = false;
      Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
    })
  }

  updateAutoRenew(uuid: string, event: any,item: any) {
    Swal.fire({
      title: i18n.are_you_sure,
      text: i18n.billing.stop_auto_renew,
      icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: i18n.yes,
      cancelButtonText: i18n.no_cancel_it
    }).then(result => {
      if (result.value) {
        let fd: any = {};
        fd.uuid = uuid;
        this.loaderService.startLoading();
        this.billingService.offAutoRenew(fd).subscribe((data: any) => {
          this.loaderService.stopLoading();
          event.target.disabled = true;
          this.getMySubscription();
          setTimeout(function () {
            Swal.fire(i18n.done, i18n.billing.auto_renew, 'success');
          }, 0);

        }, err => {
          this.loaderService.stopLoading();
          // event.target.disabled = false;
          event.target.checked = false;
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        })
      }else{
        event.target.checked = false;
        return false;
      }
    });
  }

  cancelAutoRenewOff(uuid: string, event: any,item: any) {
    Swal.fire({
      title: i18n.are_you_sure,
      text: i18n.billing.cancel_auto_renew_off,
      icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: i18n.yes,
      cancelButtonText: i18n.no_cancel_it
    }).then(result => {
      if (result.value) {
        this.loaderService.startLoading();
        this.billingService.deleteCancelRequest(uuid).subscribe((data: any) => {
          this.loaderService.stopLoading();
          this.getMySubscription();
          setTimeout(function () {
            Swal.fire(i18n.done, i18n.billing.auto_renew_on, 'success');
          }, 0);

        }, err => {
          this.loaderService.stopLoading();
          // event.target.disabled = false;
          event.target.checked = false;
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        })
      }else{
        event.target.checked = true;
        return false;
      }
    });
  }

  openAddCardModal() {
    const modalRef = this.modalService.open(AddCardComponent);
    // Set id on modal dialog
    // modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.id = "taxdetails";
    modalRef.result.then(result => {
      this.getMySubscription();
    }, fallbackResult => {
    })
  }
  

  planNameAsPerVersion(planName: string) {
    if (planName == 'invoice-basic')
      return i18n.plan.invoice_basic_plan;
    if (planName == 'invoice-pro')
      return i18n.plan.invoice_pro_plan;
    if (planName == 'invoice-enterprise')
      return i18n.plan.invoice_enterprise_plan;
    if (planName == 'online-store-basic')
      return i18n.plan.online_store_basic_plan;
    if (planName == 'online-store-pro')
      return i18n.plan.online_store_pro_plan;
    if (planName == 'online-store-enterprise')
      return i18n.plan.online_store_enterprise_plan;
    if (planName == 'online-ordering-basic')
      return i18n.plan.online_ordering_basic_plan;
    if (planName == 'online-ordering-pro')
      return i18n.plan.online_ordering_pro_plan;
    if (planName == 'online-ordering-enterprise')
      return i18n.plan.online_ordering_enterprise_plan;
    if (planName == 'complete-solution')
      return i18n.plan.complete_solution_plan;
    if (planName == 'individual')
      return i18n.plan.individual_plan;
    if (planName == 'professional')
      return i18n.plan.professional_plan;
    if (planName == 'business')
      return i18n.plan.business_plan;
	}

}
